// @flow
import { theme } from './theme'

export const VARIANT_DANGER: 'danger' = 'danger'
export const VARIANT_WARNING: 'warning' = 'warning'
export const VARIANT_SUCCESS: 'success' = 'success'
export const VARIANT_SECONDARY: 'secondary' = 'secondary'
// pseudo-type used only for styling but not passed as a type
export const VARIANT_DISABLED = 'disabled'

export const variantColorMap = {
  [VARIANT_DANGER]: theme.colors.red,
  [VARIANT_WARNING]: theme.colors.warningOrange,
  [VARIANT_SUCCESS]: theme.colors.green,
  [VARIANT_SECONDARY]: theme.colors.blueCommon,
  [VARIANT_DISABLED]: theme.colors.grayDark,
}

export type VariantTypes = typeof VARIANT_DANGER
  | typeof VARIANT_WARNING | typeof VARIANT_SUCCESS | typeof VARIANT_SECONDARY
